export const FETCHED_REDIRECTS = 'FETCHED_REDIRECTS';
export const FETCHED_REDIRECT = 'FETCHED_REDIRECT';
export const CREATED_REDIRECT = 'CREATED_REDIRECT';
export const UPDATED_REDIRECT = 'UPDATED_REDIRECT';
export const DELETED_REDIRECT = 'DELETED_REDIRECT';
export const FETCHED_STATUSES = 'FETCHED_STATUSES';
export const ADD_BULK_REDIRECTS_DOCUMENT = 'ADD_BULK_REDIRECTS_DOCUMENT';
export const DELETE_BULK_REDIRECTS_DOCUMENT = 'DELETE_BULK_REDIRECTS_DOCUMENT';
export const GET_BULK_UPLOAD_ERRORS = 'GET_BULK_UPLOAD_ERRORS';
export const BULK_REDIRECTS_UPLOADED = 'BULK_REDIRECTS_UPLOADED';


// WEBPACK FOOTER //
// ./src/containers/redirects/types.js